const steps = [
  {
    index: '01',
    en: 'FIND',
    zh: '寻找一味',
    desc: '从中国美食、地方文化、民间故事中寻找创作原点。',
    icon: 'ri-search-eye-line',
  },
  {
    index: '02',
    en: 'DISCOVER',
    zh: '进入一境',
    desc: '寻找这道食物背后的城市、地域和东方风土。',
    icon: 'ri-compass-3-line',
  },
  {
    index: '03',
    en: 'FEEL',
    zh: '理解一愿',
    desc: '找到今天的人，为什么依然需要它。',
    icon: 'ri-heart-3-line',
  },
  {
    index: '04',
    en: 'REIMAGINE',
    zh: '重新想象',
    desc: '将传统文化转化为年轻、当代、国际化的视觉语言。',
    icon: 'ri-magic-line',
  },
  {
    index: '05',
    en: 'CREATE',
    zh: '创造角色',
    desc: '让一道菜、一个地方、一种情绪，成为一个真正拥有性格的角色。',
    icon: 'ri-palette-line',
  },
  {
    index: '06',
    en: 'PLAY',
    zh: '进入生活',
    desc: '潮玩、文创、联名、空间、内容……让文化从「被观看」变成「被拥有」。',
    icon: 'ri-gamepad-line',
  },
];

export default function HowWeCreate() {
  return (
    <section className="bg-background-50 py-16 md:py-28">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="reveal lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <div className="mb-6 flex items-center gap-3">
                <span className="text-[11px] tracking-[0.34em] text-primary-600 uppercase">
                  Section 03
                </span>
                <span className="h-px w-8 bg-primary-300"></span>
                <span className="text-[11px] tracking-[0.28em] text-foreground-400 uppercase">
                  How We Create
                </span>
              </div>
              <h2 className="font-heading text-3xl leading-snug text-foreground-950 md:text-4xl">
                从一道菜，
                <br />
                到一个 IP
              </h2>
              <p className="mt-6 max-w-sm text-sm leading-relaxed text-foreground-600 md:text-base">
                我们用六个步骤，把中国味道翻译成当代年轻人愿意亲近、理解和收藏的东方潮玩。
              </p>
              <div className="mt-8 hidden h-24 w-px bg-gradient-to-b from-primary-400 to-transparent lg:block"></div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative">
              {steps.map((step, index) => (
                <li
                  key={step.index}
                  className="reveal relative flex gap-5 pb-8 last:pb-0 md:gap-7"
                  style={{ transitionDelay: `${index * 90}ms` }}
                >
                  <div className="relative flex flex-col items-center">
                    <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-primary-200 bg-primary-50 text-primary-600 md:h-14 md:w-14">
                      <i className={`${step.icon} text-lg md:text-xl`}></i>
                    </span>
                    {index < steps.length - 1 && (
                      <span className="mt-1 w-px flex-1 bg-background-300/70"></span>
                    )}
                  </div>
                  <div className="flex-1 pb-1 pt-1">
                    <div className="flex items-baseline gap-3">
                      <span className="font-heading text-lg text-accent-600">{step.index}</span>
                      <span className="text-[11px] tracking-[0.24em] text-foreground-400 uppercase">
                        {step.en}
                      </span>
                    </div>
                    <h3 className="mt-2 font-heading text-xl text-foreground-950 md:text-2xl">
                      {step.zh}
                    </h3>
                    <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
                      {step.desc}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}